
import { defineComponent, computed, PropType } from 'vue'

export default defineComponent({
  name: 'SocialPreviewTwitter',
  props: {
    image: {
      type: [String, null] as PropType<string | null>,
      default: null
    },
    title: {
      type: [String, null] as PropType<string | null>,
      default: null
    },
    description: {
      type: [String, null] as PropType<string | null>,
      default: null
    },
    aspectRatio: {
      type: String,
      required: true
    }
  },
  setup (props) {
    const truncatedString = (s: string | null, length: number): string => {
      if (!s) {
        return ''
      }
      const suffix = s.length > length ? '...' : ''
      return s.substr(0, length - 1) + suffix
    }

    const titleTruncated = computed<string>(() =>
      truncatedString(props.title, 65)
    )

    const descriptionTruncated = computed<string>(() =>
      truncatedString(props.description, 200)
    )

    return {
      titleTruncated,
      descriptionTruncated
    }
  }
})
